exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-picker[data-v-4ec952a0]{min-width:395px!important}", ""]);

// exports
